import { render, staticRenderFns } from "./healthTreatRecord.vue?vue&type=template&id=368a2c0e&scoped=true&"
import script from "./healthTreatRecord.vue?vue&type=script&lang=js&"
export * from "./healthTreatRecord.vue?vue&type=script&lang=js&"
import style0 from "./healthTreatRecord.vue?vue&type=style&index=0&id=368a2c0e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "368a2c0e",
  null
  
)

export default component.exports